module.exports = __webpack_public_path__ + "assets/img/67@3x.425b2861.png";